export default {
  getNavMenuItems: state => state.navMenuItems,
  getActiveNavMenuItemId: state => state.activeNavMenuItemId,
  getStorageSpace: state => state.storageSpace,
  getSetupArchivePasswordStatus: state => state.setupArchivePasswordStatus,
  getArchiveDeletionStatus: state => state.archiveDeletionStatus,
  getCleanupStatus: state => state.cleanupStatus,
  getContentItems: state => state.contentItems,
  getFetchNavMenuItemsStatus: state => state.fetchNavMenuItemsStatus,
  getFetchStorageSpaceStatus: state => state.fetchStorageSpaceStatus,
  getFetchContentItemsStatus: state => state.fetchContentItemsStatus,
  getPostLoginOpenArchiveId: state => state.postLoginOpenArchiveId,
  getPostLoginOpenNavMenuId: state => state.postLoginOpenNavMenuId,
  getActiveContentType: state => state.activeContentType,
  getSharedContentItems: state => state.sharedContentItems,
  getFetchSharedContentItemsStatus: state => state.fetchSharedContentItemsStatus,
  getUserSubscription: state => state.userSubscription,
  getUserSubscriptionType: state => state.userSubscriptionType,
  getAppFeatures: state => state.appFeatures,
  getFileVersions: state => state.fileVersions,
  getFetchFileVersionsStatus: state => state.fetchFileVersionsStatus,
  getFdLink: state => state.fdLink,
  getFetchFdLinkStatus: state => state.fetchFdLinkStatus,
  getSignFileLink: state => state.signFileLink,
  getSignFileStatus: state => state.signFileStatus,
  getSharedLink: state => state.sharedLink,
  getCreateSharedLinkStatus: state => state.createSharedLinkStatus,
  getDeleteSharedLinkStatus: state => state.deleteSharedLinkStatus,
  getSharedLinkSettings: state => state.sharedLinkSettings,
  getFetchSharedLinkStatus: state => state.fetchSharedLinkStatus,
  getUpdateSharedLinkStatus: state => state.updateSharedLinkStatus,
  getSearchEnabled: state => state.searchEnabled,
  getBrandName: state => state.brandName,
  getSpaceFreeAfterCleanup: state => state.spaceFreeAfterCleanup,
  getCleanupBoxName: state => state.cleanupBoxName,
  getCleanupProgressPercent: state => state.cleanupProgressPercent,
  getCleanupStage: state => state.cleanupStage,
  getSearchResultReceived: state => state.searchResultReceived,
  getActiveVersionPath: state => state.activeVersionPath,
  getActiveVolumePath: state => state.activeVolumePath,
  getActiveFolderItem: state => state.activeFolderItem
};
